module.exports = __webpack_public_path__ + "static/neunsight-47c8e74eeb93f8e38e66c3630a916d66.png";